// extracted by mini-css-extract-plugin
module.exports = {"card":"Diferenciadores_card__hy9n8","card2":"Diferenciadores_card2__1R_-_","list":"Diferenciadores_list__334Vn"};